import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';

import {
  Button,
  Col,
  Flex,
  Form,
  Grid,
  SanityBlockContent,
  Section,
} from '../../common';

const StyledHeroHeadline = styled.h1`
  color: ${(props) => props.$headline};
  ${tw`text-3xl font-bold leading-tight md:text-4xl lg:text-5xl xl:text-6xl`};
`;

const StyledHeroSubheadline = styled.div`
  color: ${(props) => props.$subheadline};
  & a {
    color: ${(props) => props.$aColor} !important;
    &:hover {
      color: ${(props) => props.$aColorHover} !important;
    }
  }
`;

const HeroForm = ({ sanity, page }) => {
  const {
    _rawHeroSubheadline,
    heroBgImg,
    heroHeadline,
    heroAddCtaButtons,
    heroPrimaryCtaButtonLabel,
    heroPrimaryCtaButtonLink,
    heroSecondaryCtaButtonLabel,
    heroSecondaryCtaButtonLink,
  } = page;

  const { colors } = sanity;

  return (
    <Section
      padding="custom"
      idName="hero-form"
      classes="relative flex flex-col place-content-center place-items-center pt-[4rem] pb-[7rem] lg:pt-[8rem] space-y-24"
    >
      <div className="absolute inset-0">
        <GatsbyImage
          image={heroBgImg?.asset?.gatsbyImageData}
          alt={heroBgImg?.alt}
          className="object-cover w-full h-full"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-blue-950/100 via-blue-900/90 via-blue-950/70 via-90% to-blue-950/40" />
      </div>

      <Grid classes="lg:grid-cols-5 gap-y-16 lg:gap-24 sm:max-w-3xl md:max-w-3xl lg:max-w-5xl xl:max-w-7xl place-items-center">
        <Col
          animationDelay={0}
          classes="order-1 lg:col-span-3 p-4 lg:p-0 relative space-y-8"
        >
          <StyledHeroHeadline
            className="text-center lg:text-left"
            $headline={colors?.hero?.headline}
          >
            <span className="drop-shadow-headline-lg">{heroHeadline}</span>
          </StyledHeroHeadline>
          <StyledHeroSubheadline
            className="text-lg font-medium sm:text-lg md:text-lg lg:text-xl xl:text-xl 2xl:text-2xl"
            $subheadline={colors?.neutral?.white}
            $aColor={colors?.accent?.default}
            $aColorHover={colors?.accent?.light}
          >
            <SanityBlockContent sanity={sanity} blocks={_rawHeroSubheadline} />
          </StyledHeroSubheadline>

          {heroAddCtaButtons && (
            <Flex classes="pt-2 gap-6 flex-col lg:flex-row">
              <Button
                sanity={sanity}
                label={heroPrimaryCtaButtonLabel}
                internalLink={heroPrimaryCtaButtonLink?.slug?.current}
              />
              <Button
                secondaryBtn
                sanity={sanity}
                label={heroSecondaryCtaButtonLabel}
                internalLink={heroSecondaryCtaButtonLink?.slug?.current}
              />
            </Flex>
          )}
        </Col>

        <Col
          animationDelay={0.3}
          classes="order-2 lg:col-span-2 p-3 lg:p-0 relative"
        >
          <div className="overflow-hidden">
            <Form formName="form-hero" page={page} sanity={sanity} />
          </div>
        </Col>
      </Grid>
    </Section>
  );
};

export { HeroForm };
